import "./Cgu.css";
export default function Cgu() {

    return (
        <div className="cgu-container">
            <div>
            <h2>1. OBJET</h2>
            <p>
                Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités d'accès et d'utilisation de la plateforme Intereseaux.com, éditée par la société Intereseaux / 89319155100017, permettant la mise en relation entre :
            </p>
            <ul>
                <li><strong>Les Clients </strong>: particuliers ou entreprises déposant des demandes de services ;</li>
                <li><strong>Les Prestataires </strong>: entreprises ou professionnels exerçant en France dans différents secteurs (BTP, informatique, services, etc.) ;</li>
                <li><strong>Les Donneurs d'ordres </strong>: entreprises de grande envergure publiant des appels d'offres.</li>
            </ul>
            <p>
                Intereseaux.com (ci-après « la Plateforme ») permet notamment :
            </p>
            <ul>
                <li>le dépôt de projets par les Clients ;</li>
                <li>la publication d'appels d'offres par les Donneurs d'ordres ;</li>
                <li>la consultation et l'expression d'intérêt via un système de likes ;</li>
                <li>la mise en relation via un système de matchs ;</li>
                <li>l'échange via une messagerie instantanée ;</li>
                <li>l'achat d'abonnements ou crédits pour les Prestataires ;</li>
                <li>le paiement sécurisé via Stripe.</li>
            </ul>
            <p>L'utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU.</p>
        </div>
            <div>
                <h2>2. DÉFINITIONS</h2>
                <ul>
                    <li>Client : utilisateur déposant un projet.</li>

                    <li>Prestataire : professionnel ou entreprise proposant des services.</li>

                    <li>Donneur d'ordres (DO) : entreprise publiant des appels d'offres.</li>

                    <li>Projet : demande de service publiée par un Client.</li>

                    <li>Appel d'offres : projet de grande envergure publié par un Donneur d'ordres.</li>

                    <li>Like : marque d'intérêt envoyée à un projet ou appel d'offres.</li>

                    <li>Match : mise en relation automatique lorsque deux utilisateurs se “likent” mutuellement.</li>

                    <li>Messagerie : système de chat interne disponible uniquement après match.</li>

                    <li>Stripe : fournisseur de services de paiement utilisé par la Plateforme.</li>
                </ul>
            </div>
            <div>
                <h2>3. ACCÈS À LA PLATEFORME</h2>
                <p>L'accès au site est gratuit.</p>
                <p>Certaines fonctionnalités nécessitent la création d'un compte utilisateur selon un des trois profils.</p>
                <p>La Plateforme se réserve le droit de :</p>
                <ul>
                    <li>suspendre ou supprimer un compte en cas de non-respect des CGU</li>
                    <li>limiter ou restreindre l'accès en cas de comportement abusif</li>
                </ul>
            </div>
            <div>
                <h2>4. INSCRIPTION</h2>
                <p>Chaque utilisateur doit fournir des informations exactes lors de l'inscription.</p>
                <h3>4.1 Pour les Prestataires</h3>
                <ul>
                    <li>informations professionnelles (SIRET, adresse, secteur d'activité, etc.)</li>
                    <li>justificatifs possibles (statut, licences, assurances…)</li>
                </ul>
                <h3>4.2 Pour les Clients</h3>
                <ul>
                    <li>aucune obligation d'être une entreprise</li>
                    <li>coordonnées nécessaires pour faciliter la mise en relation</li>
                </ul>
                <h3>4.3 Pour les Donneurs d'ordres</h3>
                <ul>
                    <li>entreprise enregistrée</li>
                    <li>informations contractuelles nécessaires à la publication des appels d'offres</li>
                </ul>
            </div>
            <div>
                <h2>5. FONCTIONNEMENT DE LA PLATEFORME</h2>
                <h3>5.1 Dépôt de projets (Clients)</h3>
                <p>Gratuit.</p>
                <h3>5.2 Dépôt d'appels d'offres (Donneurs d'ordres)</h3>
                <p>Gratuit</p>
                <h3>5.3 Achat de crédits Likes (Prestataires → DO)</h3>
                <p>Pour exprimer un intérêt sur un appel d’offres de Donneur d’ordres, le Prestataire doit acheter un ou plusieurs crédits Like :

                </p>
                <ul><li>49,90€ TTC / unité</li></ul>

                <h3>5.4 Abonnements Prestataires (Likes illimités Clients)</h3>

                <p>Pour liker les projets Clients, les Prestataires doivent souscrire un abonnement :</p>
                <ul>
                    <li>Abonnement Premium : 29,90 € TTC / mois, permet aux prestataires de liker les projets en illimité sur tout les secteurs</li>
                    <li>Abonnement CodePlace : 19,90 € TTC / mois, permet aux prestataires de liker les projets en illimité uniquement du secteur Numérique et Informatique</li>
                </ul>
                <p>Renouvellement mensuel automatique.</p>
                <h3>5.5 Offres d'essais</h3>
                <p>Pour liker les projets Clients, les Prestataires peuvent également opter pour nos offres d'essais :</p>
                <ul>
                    <li>Starter 7 jours : 14,90 € TTC, permet aux prestataires de liker les projets en illimité pendant 7 jours</li>
                    <li>Starter 24h : 4,90 € TTC, permet aux prestataires de liker les projets en illimité pendant 24h</li>
                </ul>
                <p>Pas de renouvellement automatique</p>
                <h3>5.6 Match & messagerie</h3>
                <p>Lorsqu'un Client/Prestataire ou DO/Prestataire se likent mutuellement, un match est créé et la messagerie instantanée s'active.</p>
                <h3>5.7 Dépôt d'une proposition commerciale (Prestataire)</h3>
                <p>Après négotiation via la messagerie avec un client ou un donneur d'ordres, le prestataire peut déposer une proposition commerciale, en indiquant clairement son tarif et ses conditions.</p>
                <p>Une fois la proposition acceptée par le client ou le donneur d'ordres, le prestataire s'engage à respecter son engagement envers celui-ci au tarif défini dans cette proposition</p>
                <h3>5.8 Validation d'une proposition commerciale(Client ou Donneur d'Ordres)</h3>
                <p>Lorsque le Client ou le donneur d'ordres accepte une proposition d'un Prestataire, une commission est appliquée :</p>
                <ul>
                    <li>
                        7% du montant HT du montant demandé dans la proposition pour la réalisation du projet
                    </li>
                    <li>+ 0,30 € de frais de service</li>
                </ul>
                <p>
                    Intereseaux n’intervient pas dans la gestion ou la sécurisation des paiements entre Clients/Donneurs d'ordres et Prestataires.
                    La relation contractuelle et financière entre ces parties est indépendante de la Plateforme.
                    Toutefois, pour valider une proposition commerciale, le Client ou le Donneur d’ordres doit régler manuellement une commission
                    à Intereseaux correspondant à 7% du montant HT de la proposition acceptée, majorée de 0,30 € de frais de service.
                    Ce paiement s’effectue exclusivement par carte bancaire via Stripe.
                    Sans règlement de cette commission, la proposition ne peut pas être validée ni confirmée par la Plateforme.
                </p>




            </div>
            <div>
                <h2>6. CONDITIONS FINANCIÈRES</h2>
                <h3>6.1 Paiement sécurisé via Stripe</h3>
                <p>
                    Tous les paiements (abonnements, crédits likes, commissions…) sont gérés par Stripe, selon leurs propres conditions.
                </p>
                <p>
                    La Plateforme ne stocke aucune donnée bancaire.
                </p>
                <h3>6.2 Abonnements</h3>
                <ul>
                    <li>
                        Paiement mensuel
                    </li>
                    <li>Renouvellement automatique</li>
                    <li>Résiliable à tout moment, avec effet à la prochaine échéance</li>
                    <li>Aucun remboursement au prorata</li>
                </ul>
                <h3>6.3 Achats de crédits Like</h3>
                <ul>
                    <li>Achat unique</li>
                    <li>Non remboursables</li>
                    <li>Non transférables</li>
                    <li>Utilisables exclusivement pour les appels d'offres DO</li>
                </ul>
                <h3>6.4 Commissions Clients et Donneur d'ordres</h3>
                <p>
                    Payable par carte bancaire via Stripe pour accepter la proposition commerciale du prestataire.
                </p>
            </div>
            <div>
                <h2>7. RESPONSABILITÉS</h2>
                <h3>7.1 Intereseaux </h3>
                <p>La Plateforme agit uniquement comme intermédiaire technique permettant la mise en relation. Intereseaux :</p>
                <ul>
                    <li>ne garantit pas la conclusion d'un contrat entre les utilisateurs ;</li>
                    <li>ne garantit pas la qualité, conformité ou réalisation des prestations ;</li>
                    <li>n'assume aucune responsabilité sur les paiements entre utilisateurs pour la réalisation des prestations.</li>
                </ul>


                <p><strong>Paiements et transactions entre utilisateurs</strong> :<br />
                    Intereseaux ne gère pas, n'intervient pas et ne conserve pas les paiements effectués directement entre Client et Prestataire. Tout règlement pour la prestation est effectué hors plateforme entre les parties (par virement, chèque, paiement externe, etc.). Par conséquent, Intereseaux ne saurait être tenue responsable des retards de paiement, impayés, fraudes ou litiges financiers entre utilisateurs.</p>


                <p><strong>Commission ≠ Paiement de la prestation</strong> :<br />
                    La commission payée lors de l'acceptation d'une proposition commerciale rémunère les services de mise en relation et de gestion (accès aux outils, génération de facture relative à la commission, etc.). Elle ne constitue en aucun cas le paiement de la prestation convenue entre Client et Prestataire.</p>


                <p><strong>Limitation de responsabilité en cas d'escroquerie</strong> :<br />
                    Les utilisateurs reconnaissent que toute transaction réalisée en dehors de la Plateforme se fait à leurs risques exclusifs. Intereseaux ne garantit pas la solvabilité des utilisateurs et ne peut être tenue responsable des fraudes ou arnaques intervenant lors d'échanges hors plateforme.</p>
                <h3>7.2 Utilisateurs</h3>
                <p>Les utilisateurs s'engagent à :</p>
                <ul>
                    <li>fournir des informations exactes</li>
                    <li>ne pas usurper d'identité</li>
                    <li>ne pas publier de contenu illicite</li>
                    <li>respecter les règles de politesse et non-harcèlement</li>
                </ul>

            </div>
            <div>
                <h2>8. PROPRIÉTÉ INTELLECTUELLE</h2>
                <p>Tout contenu présent sur la Plateforme est protégé :</p>
                <ul>
                    <li>interface</li>
                    <li>textes</li>
                    <li>images</li>
                    <li>code</li>
                    <li>logo Intereseaux</li>
                </ul>
                <p>Toute reproduction est interdite sans autorisation.</p>
            </div>
            <div>
                <h2>9. DONNÉES PERSONNELLES</h2>
                <p>Intereseaux collecte et traite les données conformément au RGPD.</p>
                <p>Les données peuvent être utilisées pour :</p>
                <ul>
                    <li>créer des comptes</li>
                    <li>faciliter la mise en relation</li>
                    <li>proposer des projets pertinents</li>
                    <li>sécuriser les paiements via Stripe</li>
                </ul>
                <p>Chaque utilisateur dispose d'un :</p>
                <ul>
                    <li>droit d'accès</li>
                    <li>droit de rectification</li>
                    <li>droit à la suppression</li>
                    <li>droit à la portabilité</li>
                    <li>droit d'opposition</li>
                </ul>
            </div>
            <div>
                <h2>10. SUSPENSION OU SUPPRESSION DE COMPTE</h2>
                <p>Peut intervenir en cas de :</p>
                <ul>
                    <li>fraude</li>
                    <li>non-respect des CGU</li>
                    <li>comportements inappropriés</li>
                    <li>spamming ou démarchage non autorisé</li>
                    <li>litige grave</li>
                </ul>
            </div>
            <div>
                <h2>11. MODIFICATIONS DES CGU</h2>
                <p>Intereseaux se réserve le droit de modifier les présentes CGU à tout moment.</p>
                <p>Les utilisateurs seront informés lors de leur prochaine connexion.</p>
            </div>
            <div>
                <h2>12. LOI APPLICABLE & LITIGES</h2>
                <p>Les présentes CGU sont soumises au droit français.</p>
                <p>En cas de litige, les parties s'engagent à rechercher une solution amiable.</p>
                <p>À défaut, compétence exclusive des tribunaux français.</p>
            </div>
            <div>
                <h2>13. CONTACT</h2>
                <p>INTERESEAUX</p>
                <p>Email: intereseaux@gmail.com</p>
                <p>Adresse : 21 RUE DE LA VARLOPE<br />
                    95490 VAUREAL, FRANCE</p>
            </div> </div>
    );
}

